import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService, ProductService } from '@app/core';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';
import { FileService } from '@app/core/service/file.service';
import { HttpEvent, HttpEventType, HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  productsForm: FormGroup;
  categories: Category[];
  products: Product[];
  product: any = {};

  // unidades de la vista
  unidades: any[] = ['a', 'b', 'c'];

  // subir foto
  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  imagenURL: any = {};
  progress = 0;

  pager = {};
  pageOfItems: any = [];

  productos: Paginated;

  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;

  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    private productService: ProductService,
    private fileService: FileService
  ) {}

  ngOnInit() {
    this.createForm();
    this.listCategorys();
    this.listProducts();
    this.productService
      .getProductos()
      .then(productos => (this.productos = productos));
    this.searchTermStream.subscribe((term: string) => {
      this.productService.search(term).then((productos: any) => {
        this.currentSearchTerm = term;
        this.updateBookings(productos);
      });
    });
  }

  updateBookings(productos: Paginated) {
    const productosWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      productos
    );
    this.productos = productosWithUpdatedNavs;
  }

  updateNavUrls(term: string, productos: Paginated): Paginated {
    if (term) {
      if (productos.prev_page_url) {
        productos.prev_page_url += `&term=${term}`;
      }
      if (productos.next_page_url) {
        productos.next_page_url += `&term=${term}`;
      }
    }
    return productos;
  }

  prevPage() {
    this.productService
      .getProductosAtUrl(this.productos.prev_page_url)
      .then((productos: any) => {
        this.updateBookings(productos);
      });
  }

  nextPage() {
    this.productService
      .getProductosAtUrl(this.productos.next_page_url)
      .then((productos: any) => {
        this.updateBookings(productos);
      });
  }

  search(term: string) {
    this.searchTermStream.next(term);
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = _event => {
      this.previewUrl = reader.result;
    };
  }

  subirFoto() {
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.fileUploadProgress = '0%';
    this.fileService.sendFile(formData).subscribe(
      (event: HttpEvent<any>) => {
        console.log(this.imagenURL);
        switch (event.type) {
          case HttpEventType.Sent:
            console.log('Request has been made!');
            break;
          case HttpEventType.ResponseHeader:
            console.log('Response header has been received!');
            break;
          case HttpEventType.UploadProgress:
            this.fileUploadProgress =
              Math.round((event.loaded / event.total) * 100) + '%';
            this.progress = Math.round((event.loaded / event.total) * 100);
            console.log(`Uploaded! ${this.progress}%`);
            break;
          case HttpEventType.Response:
            this.fileUploadProgress = '';
            this.imagenURL = event.body;
            console.log('archivo creado con exito!', event.body);
            setTimeout(() => {
              this.progress = 0;
            }, 1500);
        }
      },
      error => {
        console.log(error.error);
      }
    );
  }

  listCategorys() {
    this.categoryService.getAll().subscribe(
      data => {
        this.categories = data;
        // console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  createForm() {
    this.productsForm = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      codigo: ['', [Validators.required]],
      // foto: ['', [Validators.required]],
      marca: ['', [Validators.required]],
      unidad: ['', [Validators.required]],
      abreviacion: ['', [Validators.required]],
      categoria: ['', [Validators.required]]
    });
  }

  registerProducts() {
    const formData = new FormData();

    // this.product.nombre = this.productsForm.value.nombre;
    //  this.product.descripcion = this.productsForm.value.descripcion;
    //  this.product.codigo = this.productsForm.value.codigo;
    //  this.product.marca = this.productsForm.value.marca;
    //  this.product.unidad = this.productsForm.value.unidad;
    //  this.product.stock = this.productsForm.value.stock;
    //  this.product.abreviacion = this.productsForm.value.abreviacion;
    //  this.product.foto = formData;
    //   this.product.categoria = this.productsForm.value.categoria;

    formData.append('file', this.fileData);
    formData.append('nombre', this.productsForm.value.nombre);
    formData.append('descripcion', this.productsForm.value.descripcion);
    formData.append('codigo', this.productsForm.value.codigo);
    formData.append('marca', this.productsForm.value.marca);
    formData.append('unidad', this.productsForm.value.unidad);
    formData.append('stock', this.productsForm.value.stock);
    formData.append('abreviacion', this.productsForm.value.abreviacion);
    formData.append('categoria', this.productsForm.value.categoria);

    // console.log(formData);

    this.productService.create(formData).subscribe(
      data => {
        this.listProducts();
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  listProducts() {
    this.productService.getAll().subscribe(
      (data: any) => {
        this.products = data;
        //  console.log(data);
      },
      (error1: any) => {
        console.log(error1.error);
      }
    );
  }

  buscarCategoria(categoria_id: number) {}

  editProduct(id: string) {
    this.productService.getById(id).subscribe(data => {
      // console.log(data);
      this.productsForm.setValue({
        // foto: ' a.jpg',
        nombre: data.nombre,
        descripcion: data.descripcion,
        marca: data.marca,
        abreviacion: data.abreviacion,
        codigo: data.codigo,
        unidad: data.unidad,
        stock: data.stock,
        categoria: data.categoria_id
        // categoria_id:data.categoria_id
      });
    });
  }
}
